import styled from 'styled-components';

export const FormListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div {
    margin-right: 50px;
    margin-bottom: 16px;
  }

  .ant-form-item {
    width: 288px;
  }
`;

export const DeleteItemContainer = styled.div`
  display: flex;
  & > div:nth-child(2) {
    margin-left: 16px;
    margin-top: 33px;
    align-self: flex-start;
    cursor: pointer;
  }
`;

export const GanttsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0px;

  & > div:not(:last-child) {
    border-bottom: 1px solid #cfd4dd;
    padding-bottom: 24px;
    margin-bottom: 24px;
  }
`;

export const GanttInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: 1300px;

  & > div {
    margin-right: ${({ isView }: { isView?: boolean }) => (isView ? '84px' : '48px')};
  }
`;

export const GanttColorWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 10px;
  display: flex;

  & > div {
    margin-right: 84px;
  }
  .ant-form-item-has-success {
    label {
      color: ${({ theme }) => theme.colors.primary.grey};
    }
  }
`;
